// extracted by mini-css-extract-plugin
module.exports = {"textWrap":"textWrap__3rxoK"};